var _rect, _rect2, _rect3, _rect4, _rect5, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowerCabinet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 277,
    viewBox: "0 0 542 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 52,
    width: 269,
    height: 180,
    fill: "#A1614D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 71,
    width: 97,
    height: 145,
    rx: 8,
    fill: "#E1976D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 71,
    width: 97,
    height: 145,
    rx: 8,
    fill: "#E1976D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 127,
    width: 30,
    height: 8,
    rx: 4,
    transform: "rotate(90 223 127)",
    fill: "#984B20"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 127,
    width: 30,
    height: 8,
    rx: 4,
    transform: "rotate(90 303 127)",
    fill: "#984B20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259 54L259 230",
    stroke: "#4A3A2C",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerCabinet);
export default __webpack_public_path__ + "static/media/lower_cabinet.b056cf6487f17f6cb52dc2d9406e5f29.svg";
export { ForwardRef as ReactComponent };